const name = 'HeaderHideToTop';
const properties = {
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        compMeasures: {
            type: 'object',
            properties: {
                height: {
                    type: 'number',
                },
            },
        },
    },
};
const GUTTER = 5; // px
function animate(kit, elements, duration, delay, { compMeasures, ...params }) {
    const sequence = kit.sequence(params);
    const headerHeight = compMeasures.height;
    sequence.add(kit.animate('BasePosition', elements, duration, delay, {
        ease: 'Linear.easeNone',
        from: { y: 0 },
        to: { y: -1 * (headerHeight + GUTTER) },
    }));
    // hide additional stuff overflowing the header, such as shadow or member's area menu when open
    sequence.add(kit.animate('BaseFade', elements, 0.2, 0.1, {
        ease: 'Linear.easeIn',
        to: { autoAlpha: 0 },
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=headerHideToTop.js.map